import {
  Avatar,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import { ItemListElement } from "../SortedItemsList/SortedItemsList";
import FormatService from "../../services/formatService";
import PageControllers from "../PageControllers/PageControllers";
import { useEffect, useState } from "react";

interface FullListElementsProps {
  title: string;
  elements: Array<ItemListElement>;
  totalElements: number;
  lastPage: number;
  defaultAvatarImg: string;
  renderName?: Function;
  renderValue?: Function;
  searchByPage?: Function;
  handleOnClick?: Function;
  itemsPerPage: number;
  setItemsPerPage: Function;
}

const FullListElements = ({
  title,
  elements,
  defaultAvatarImg,
  renderName,
  renderValue,
  searchByPage,
  totalElements,
  lastPage,
  handleOnClick,
  itemsPerPage,
  setItemsPerPage,
}: FullListElementsProps) => {
  const [page, setPage] = useState<number>(1);

  const { getUrlLogo } = FormatService();

  const returnLogo = (item: ItemListElement) => {
    let data =
      item.logo || item.picture ? (
        <Grid item width={40}>
          <img
            className="banner"
            src={getUrlLogo(
              item.logo ? item.logo : item.picture ? item.picture : ""
            )}
            alt={"banner image"}
          />
        </Grid>
      ) : (
        <Avatar
          alt={`${item.name}`}
          src={
            item.img
              ? item.img
              : item.profile_image
                ? item.profile_image
                : defaultAvatarImg
          }
        />
      );
    return data;
  };

  const itemClick = (id: string | number) => {
    if (handleOnClick) {
      handleOnClick(id);
    }
  };

  useEffect(() => {
    if (page && searchByPage) {
      searchByPage(page);
    }
  }, [page]);

  return (
    <Grid
      item
      container
      direction="column"
      alignItems={"center"}
      sx={{ width: "100%", height: "100%", paddingBottom: "0px" }}
    >
      <Grid
        item
        container
        sx={{
          maxWidth: "1200px !important",
          marginTop: "30px",
          marginBottom: "100px",
        }}
        direction="column"
        rowSpacing={1}
        alignItems={"start"}
      >
        <Grid item paddingLeft={"14px"}>
          <Typography
            variant="whyTitle"
            sx={{ color: "#6f7d95 !important", fontSize: "1.5rem !important" }}
          >
            {title}
          </Typography>
        </Grid>
        <Grid item container spacing={2}>
          {elements.map((item) => {
            const labelId = `checkbox-list-secondary-label-${item.id}`;
            return (
              <Grid key={item.id} item xs={4}>
                <Paper
                  sx={{
                    paddingTop: "12px !important",
                    paddingBottom: "12px",
                    borderRadius: "10px",
                    backgroundColor: "white !important",
                    minHeight: "50px",
                    paddingLeft: "25px",
                    paddingRight: "25px",
                  }}
                >
                  <ListItem
                    key={item.id}
                    disablePadding
                    sx={{ width: "100%", cursor: "pointer" }}
                    onClick={() => itemClick(item.id)}
                  >
                    <ListItemAvatar>{returnLogo(item)}</ListItemAvatar>
                    <ListItemText
                      id={labelId}
                      disableTypography
                      primary={
                        <Typography variant="followCardUserName">
                          {renderName ? renderName(item.name) : item.name}
                        </Typography>
                      }
                    />
                    <ListItemText
                      id={labelId}
                      disableTypography
                      primary={
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#4663ff !important",
                            fontWeight: "600 !important",
                          }}
                          align="right"
                        >
                          {renderValue ? renderValue(item.value) : item.value}
                        </Typography>
                      }
                    />
                  </ListItem>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
        {searchByPage && totalElements > 10 && (
          <PageControllers
            setPage={setPage}
            currentPage={page}
            lastPage={lastPage}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default FullListElements;
